module.exports = __webpack_public_path__ + "f3acbe3e4fb909badb44f8671fe257ec.pdf";